import React, { useState, useCallback } from 'react';
import Cropper from 'react-easy-crop';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Slider } from '@mui/material';
import getCroppedImg from '../../../utils/cropImage';

const CropDialog = ({ imageSrc, onCancel, onCropComplete }) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  const onCropDone = async () => {
    const croppedImage = await getCroppedImg(imageSrc, croppedAreaPixels);
    onCropComplete(croppedImage);
  };

  const onCropCompleteInternal = useCallback((_, croppedPixels) => {
    setCroppedAreaPixels(croppedPixels);
  }, []);

  return (
    <Dialog open fullWidth maxWidth="sm">
      <DialogTitle>  <strong>Rogner la photo</strong></DialogTitle>
      <DialogContent>
        <div style={{ position: 'relative', width: '100%', height: 300 }}>
          <Cropper
            image={imageSrc}
            crop={crop}
            zoom={zoom}
            aspect={1} // 5x5 cm => carré
            onCropChange={setCrop}
            onZoomChange={setZoom}
            onCropComplete={onCropCompleteInternal}
          />
        </div>
        <Slider
          value={zoom}
          min={1}
          max={3}
          step={0.1}
          onChange={(e, z) => setZoom(z)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="primary" variant='outlined'>Annuler</Button>
        <Button onClick={onCropDone} color="primary" variant='contained'>Valider</Button>
      </DialogActions>
    </Dialog>
  );
};

export default CropDialog;
